import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { img1, img2 } from "../../assets/img/imgIndex";
import PageHeader from "../../components/PageHeader/PageHeader";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";

const OrdersManagementView = () => {
  const location = useLocation();
  const { id, tab, page } = location.state ?? {};
  const navigate = useNavigate();

  const [form, setForm] = useState([
    { id: 1, name: "Food Images", value: [img1, img2], type: "img" },
    { id: 2, name: "Order ID", value: "", type: "input" },
    { id: 3, name: "Food Name", value: "", type: "input" },
    { id: 4, name: "Food Type", value: "", type: "input" },
    { id: 5, name: "Seller Name", value: "", type: "input" },
    { id: 6, name: "Buyer Name", value: "", type: "input" },
    // { id: 7, name: "Order Type", value: "", type: "input" },
    { id: 8, name: "Quantity", value: "", type: "input" },
    { id: 9, name: "Qty Price", value: "", type: "input" },
    { id: 10, name: "Posted Date & Time", value: "", type: "input" },
    { id: 11, name: "Payment Type", value: "", type: "input" },
    { id: 12, name: "Delivery Type", value: "", type: "input" },
    { id: 13, name: "Delivery Location", value: "", type: "input" },
    { id: 14, name: "Description", value: "", type: "desc" },
    { id: 15, name: "Booking Date & Time", value: "", type: "input" },
    { id: 16, name: "Food Available at", value: "", type: "input" },
    ...(tab != 3
      ? [{ id: 17, name: "Order Packed Date & Time", value: "", type: "input" }]
      : []),
    ...(tab == 2
      ? [{ id: 18, name: "Sold Date & Time", value: "", type: "input" }]
      : tab == 3
        ? [
          { id: 19, name: "Cancelled Date & Time", value: "", type: "input" },
          { id: 20, name: "Cancelled Reason", value: "", type: "desc" },
        ]
        : []),
  ]);

  const fetchData = async (id) => {
    let payload = {
      booking_id: id,
    };
    let res = await post(URLS.BOOKING_VIEW, payload);
    if (res?.status == "success") {
      let d = res?.data;
      setForm((prev) =>
        prev.map((i) => {
          switch (i?.id) {
            case 1:
              return {
                ...i,
                value: d?.images || [],
              };
            case 2:
              return {
                ...i,
                value: d?.booking_id,
              };
            case 3:
              return {
                ...i,
                value: d?.food_name,
              };
            case 4:
              return {
                ...i,
                value: d?.food_type == 0 ? "Veg" : "Non-veg",
              };
            case 5:
              return {
                ...i,
                value: d?.seller_name,
              };
            case 6:
              return {
                ...i,
                value: d?.buyer_name,
              };
            // case 7:
            //   return {
            //     ...i,
            //     // value:
            //     //   d?.booking_type === "Pre Booking" ||
            //     //     d?.booking_type === 1 ||
            //     //     d?.booking_type === "1"
            //     //     ? "Pre Booking"
            //     //     : String(d?.booking_type ?? ""),
            //     value: d?.road_distance_km ? `${d.road_distance_km} km` : "",
            //   };
            case 8:
              return {
                ...i,
                value: String(d?.quantity),
              };
            case 9:
              return {
                ...i,
                value: String(d?.price),
              };
            case 10:
              return {
                ...i,
                value:
                  moment(d?.food_posted_at).format("DD-MM-YYYY , h:mm A") ??
                  "-",
              };
            case 11:
              return {
                ...i,
                value:
                  d?.payment_type == 0
                    ? "Free"
                    : d?.payment_type == 1
                      ? "Paid"
                      : "Special Recipe",
              };
            case 12:
              return {
                ...i,
                value: d?.delivery_type == 0 ? "Takeaway" : "Delivery",
              };
            case 13:
              return {
                ...i,
                value: `${String(d?.latitude)},${String(d?.longitude)}`,
                lat: d?.latitude,
                long: d?.longitude,
              };
            case 14:
              return {
                ...i,
                value: d?.description,
              };
            case 15:
              return {
                ...i,
                value:
                  moment(d?.booking_date).format("DD-MM-YYYY , h:mm A") ?? "-",
              };
            case 16:
              return {
                ...i,
                value: d?.available_at
                  ? moment(d?.available_at).format("DD-MM-YYYY , h:mm A")
                  : "-",
              };
            case 17:
              return {
                ...i,
                value: d?.packed_at
                  ? moment(d?.packed_at).format("DD-MM-YYYY , h:mm A") ?? "-"
                  : "Not Packed",
              };
            case 18:
              return {
                ...i,
                value: moment(d?.sold_at).format("DD-MM-YYYY , h:mm A") ?? "-",
              };
            case 19:
              return {
                ...i,
                value:
                  moment(d?.cancel_date).format("DD-MM-YYYY , h:mm A") ?? "-",
              };
            case 20:
              return {
                ...i,
                value: d?.cancel_reason ?? "-",
              };

            default:
              return i;
          }
        })
      );
    }
  };

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, []);

  const isPreBooking =
    form.find((item) => item.id === 7)?.value === "Pre Booking";
  return (
    <div>
      <PageHeader
        title={
          tab == 1
            ? "Booked Order's"
            : tab == 2
              ? "Sold Order's"
              : "Cancelled Order's"
        }
        showBackButton={true}
        onBackClick={() =>
          navigate("/orders", { state: { page: page || 1, tab: tab || 1 } })
        }
      />
      <div className="form-grid">
        {form.map((i) => {
          if (i.id === 16 && !isPreBooking) {
            return null;
          }

          if (i.type === "input") {
            return (
              <div className="form-item" key={i.id}>
                <div className="form-group">
                  <label>{i.name}</label>
                  <input
                    type="text"
                    value={i.value || ""}
                    readOnly
                    onClick={() => {
                      if (i.id === 12 && i.lat && i.long) {
                        window.open(
                          `https://www.google.com/maps?q=${i.lat},${i.long}`,
                          "_blank"
                        );
                      }
                    }}
                  />
                </div>
              </div>
            );
          } else if (i.type === "img") {
            return (
              <div className="form-group" key={i.id}>
                <label>{i.name}</label>
                <div className="img-row">
                  {i.value.map((it, ind) => (
                    <img
                      key={ind}
                      src={it}
                      className="food-img"
                      alt={`Food ${ind + 1}`}
                    />
                  ))}
                </div>
              </div>
            );
          } else if (i.type === "desc") {
            return (
              <div className="form-item full-width" key={i.id}>
                <div className="form-group">
                  <label>{i.name}</label>
                  <textarea
                    value={i.value || ""}
                    readOnly
                    rows={1}
                    className="desc-textarea"
                  />
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default OrdersManagementView;
